import { signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { auth, googleProvider, facebookProvider } from "../config/firebase";

const extractProfile = (user) => ({
  uid: user.uid,
  name: user.displayName || "",
  email: user.email || "",
  photo: user.photoURL || "",
  provider: user.providerData?.[0]?.providerId || "",
  at: new Date().toISOString(),
});

export const SOCIAL_PROFILE_KEY = "aio_social_profile";

export async function signInWithGoogleAccount() {
  const result = await signInWithPopup(auth, googleProvider);
  const profile = extractProfile(result.user);
  localStorage.setItem(SOCIAL_PROFILE_KEY, JSON.stringify(profile));
  return profile;
}

export async function signInWithYouTubeAccount() {
  const ytProvider = new GoogleAuthProvider();
  ytProvider.addScope("https://www.googleapis.com/auth/youtube.readonly");
  const result = await signInWithPopup(auth, ytProvider);
  const profile = extractProfile(result.user);
  localStorage.setItem(SOCIAL_PROFILE_KEY, JSON.stringify(profile));
  return profile;
}

export async function signInWithFacebookAccount() {
  const result = await signInWithPopup(auth, facebookProvider);
  const profile = extractProfile(result.user);
  localStorage.setItem(SOCIAL_PROFILE_KEY, JSON.stringify(profile));
  return profile;
}

export function getSocialErrorMessage(err) {
  const code = err?.code || "";
  if (code === "auth/popup-closed-by-user" || code === "auth/cancelled-popup-request") return "";
  if (code === "auth/operation-not-allowed")
    return "Ye login method abhi enable nahi hai. Admin ko bolo: Firebase Console → Authentication → Sign-in method → enable karein.";
  if (code === "auth/unauthorized-domain")
    return "Ye domain authorized nahi hai. Firebase Console → Authentication → Settings → Authorized domains mein add karna hoga.";
  if (code === "auth/account-exists-with-different-credential")
    return "Is email se pehle kisi aur method se login hua hai. Wahi method use karein.";
  if (code === "auth/popup-blocked") return "Popup block ho gaya — browser mein popup allow karein.";
  if (code === "auth/network-request-failed") return "Network issue — internet check karein.";
  return "Login nahi ho paya. Dobara try karein.";
}
